import React from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {RuleActionConditionItemOptions} from '../ruleActionConditionHelpers';
import {RuleConditionDefinition} from '../ruleParameterModel';

/*
 * Types.
 */

interface RuleConditionProPillProps {
  item: RuleConditionDefinition;
  itemOptions?: RuleActionConditionItemOptions;
}

/*
 * Styles.
 */

const PillLabel = styled.span`
  width: max-content;
  font-weight: ${fontWeights.semibold};
  letter-spacing: 0.2px;
  white-space: nowrap;
  display: inline-block;
  border-radius: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.greys.white};
  background-color: ${(p) => p.theme.palette.yellow.shade40};
  font-size: ${fontSizes.tiny};
  padding: 0 10px;
  margin-left: 10px;
`;

/*
 * Component.
 */

export const RuleConditionProPill = ({item, itemOptions}: RuleConditionProPillProps) => {
  const {pillLabel} = getRuleLabel(item.name);
  const shouldDisplayPro = itemOptions?.shouldDisplayPlanPill ?? true;

  if (!(shouldDisplayPro && pillLabel)) {
    return null;
  }

  return <PillLabel>{pillLabel}</PillLabel>;
};

/*
 * Helpers.
 */

const squareBracketsRegex = /\[([^\]]+)\](.*)/;

// @RULES TODO Refactor this to be able to translate labels
// Extracts the name and the pill label from a raw rule name.
export function getRuleLabel(rawLabel: string) {
  const squareBracketsMatches = rawLabel.match(squareBracketsRegex);

  if (!squareBracketsMatches) {
    return {label: rawLabel};
  }

  const [, pillLabel, label] = squareBracketsMatches;

  return {
    pillLabel,
    label: label.trim(),
  };
}
